"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Routes = void 0;
var SERVICE_PREFIX = '/capacity-planning-service/insights';
exports.Routes = {
    GET_INSIGHTS_COUNT: "".concat(SERVICE_PREFIX, "/count"),
    GET_INSIGHTS: "".concat(SERVICE_PREFIX, "/"),
    UPDATE_INSIGHT_DONE: "".concat(SERVICE_PREFIX, "/{:insightId}/done"),
    SUBMIT_INSIGHT_FEEDBACK: "".concat(SERVICE_PREFIX, "/{:insightId}/feedback"),
    QUERY_INSIGHT_FEEDBACKS: "".concat(SERVICE_PREFIX, "/feedback/query"),
    DELETE_INSIGHT_FEEDBACK: "".concat(SERVICE_PREFIX, "/{:insightId}/feedback")
};
//# sourceMappingURL=CapacityInsights.consts.js.map